import { module } from 'angular';
import templateBuilderFieldsetDisplay from './builder/display.html';

export default module('app').run(/* @ngInject */ (
	/** @type {import('angular').ITemplateCacheService} */ $templateCache,
) => {
	$templateCache.put('kform/components/fieldset/display.html', templateBuilderFieldsetDisplay);
});
